import { HTMLAttributes, ReactNode, Ref, forwardRef } from "react";

interface IView extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  enableEventCapturing?: boolean;
}

const View = forwardRef<HTMLDivElement, IView>((props, ref) => {
  const { enableEventCapturing, ...restViewProps } = props;

  return (
    <div
      {...restViewProps}
      ref={ref}
      style={{
        ...restViewProps.style,
        pointerEvents: enableEventCapturing ? "auto" : "none",
      }}
    >
      {restViewProps.children}
    </div>
  );
});

View.displayName = "View";

export default View;
